module.exports = __webpack_public_path__ + "static/media/网约车派单.5c5a9301.jpg";